import { SubmissionError, reset } from 'redux-form';
import messages from '../../locale/messages';
import history from '../../core/history';
import fetch from '../../core/fetch';
import { setRuntimeVariable } from '../../actions/runtime';
import { loadAccount } from '../../actions/account';
import { closeImportListModal } from '../../actions/modalActions';
import { referralURL } from '../../helpers/formatURL';
import { encode } from '../../helpers/queryEncryption';

async function submit(values, dispatch) {
  const resp = await fetch("/import-listing", {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      values
    }),
    credentials: "include",
  });

  const { data } = await resp.json();
  
  if (data && data?.status == 200) {
    return data;
    // dispatch(closeImportListModal());
    // dispatch(reset("ImportListingForm"));
    // history.push(`/become-a-host/${data.listingId}/home`);
  } else {
    throw new SubmissionError({ _error: messages[data.message] });
  }
}

export default submit;
